import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { manageConsent } from '../../../../../actions/user';
import classes from './ProfileWrapper.module.scss';
import ProfileCard from '../../../../common/Cards/ProfileCard/ProfileCard';
import ConsentForm from '../ConsentForm/ConsentForm';
import ProfileCardSkeleton from '../../../../common/Skeletons/ProfileCardSkeleton';
import { setNotification } from '../../../../../actions/appNotifications';
import { appNotificationsTypes } from '../../../../../utils/constants';
import SomethingWentWrong from '../../../../common/SomethingWentWrong/SomethingWentWrong';

export default function ProfileWrapper(props) {
  const { profile, error, pending, userId, children } = props;

  const dispatch = useDispatch();

  const updateConsent = (data) => {
    dispatch(manageConsent(userId, data));
  };

  useEffect(() => {
    if (error)
      dispatch(
        setNotification({
          type: appNotificationsTypes.SUCCESS,
          message: error,
          duration: 3000
        })
      );
  }, [error]);

  if (pending) {
    return (
      <section className={classes.mainContainer}>
        <ProfileCardSkeleton />
      </section>
    );
  }

  if (error) {
    return <SomethingWentWrong />;
  }

  if (profile) {
    return (
      <section className={classes.mainContainer}>
        <div className={classes.leftBlock}>
          <ProfileCard userData={profile} />
          <ConsentForm profile={profile} revoke={updateConsent} />
        </div>
        <div className={classes.rightBlock}>{children}</div>
      </section>
    );
  }
}
